import React, { Component } from 'react';
import './formSummary.less';
import { PropTypes } from 'prop-types';
import { Loader } from '@citrus/loader';
import FlashMessage from '../Common/Components/flashMessage/flashMessage.container';
import QuestionChart from './questionCharts/questionChartsFactory';
import { getSafeLocaleString } from '../Common/Services/utilities';
import { ZeroState } from '@citrus/zero-state';
import NoResult from './questionCharts/questionChartsNoResult';
import SinglePager from '../Common/Components/paging/singlePager.jsx'
import BottomPager from '../Common/Components/paging/bottomPager.jsx'

class FormSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastFormInstanceGuid: undefined,
      byQuestionPageIndex: 0,
    }
  }

  UNSAFE_componentWillMount() {
    this.initializeFormSummary();
  }
  
  componentDidUpdate() {
    this.initializeFormSummary();
  }

  isOptionEnabled(option) {
    let enabled = (this.props.options && this.props.options[option] === true) ? true : false;
    return enabled;
  }

  getOptionValue(option) {
    let value = (this.props.options && this.props.options[option]) ? this.props.options[option] : undefined;
    return value;
  }

  initializeFormSummary() {
    if (this.props.params) {
      let companyId = this.props.params.companyId;
      let employeeId = this.props.params.employeeId;
      let formInstanceGuid = this.props.params.formInstanceGuid;
      let includeParticipants = this.props.params.includeParticipants;
      let viewConfidentially = this.props.params.viewConfidentially;

      if (this.state.lastFormInstanceGuid !== formInstanceGuid) {
        this.props.getSummaryData(companyId, employeeId, formInstanceGuid, includeParticipants, viewConfidentially);
        this.setState({ lastFormInstanceGuid: formInstanceGuid });
      }
    }
  }


  renderSummaryResults() {
    let summaryData = this.props.summaryData;
    if (summaryData && summaryData.participantsResponded > 0) {
      let questionsAndAnswers = summaryData.questionsAndAnswers;
      return (!this.props.isLoading && questionsAndAnswers && <div className="col-xs-12" id="form-summary-parent" data-count={summaryData.questionCount}>
        {
          questionsAndAnswers.map((questionData, i) => {
            var questionNumber = i + 1; 
            let percentage = Math.round((questionData.responseCount / summaryData.participantCount) * 100);
            return <div key={i} className="row type-centeralign" data-automation-id={"summary-question-" + i}>
              <div className="col-xs-2">
              </div>
              <div className="col-xs-12 padding-vertical">
                <h3 data-automation-id={"question-" + (questionNumber) + "-chart-title"} >{questionNumber}. {questionData.title}</h3>
                {questionData.responseCount > 0 
                  ?
                  <QuestionChart questionData={questionData} questionNumber={questionNumber} isSummary={true}/>
                  : 
                  <NoResult number={questionNumber}/>
                }
                <p data-automation-id={"question-" + (questionNumber) + "-response-rate"} className="color-gray-darker type-semibold">{getSafeLocaleString(questionData.responseCount)} responses out of {getSafeLocaleString(summaryData.participantCount)} participants ({percentage}%) </p>
              </div>
              <div className="col-xs-2">
              </div>
            </div>
          })
        }
      </div>);
    }
    return <ZeroState
              key="summary-empty-state"
              automationId="empty-state"
              message="There are no responses yet."
              type="insufficientdata" />
  }

  renderByQuestionResults() {
    let questionIndex = this.state.byQuestionPageIndex;
    let summaryData = this.props.summaryData;
    if (summaryData && summaryData.questionsAndAnswers) {
      let questionData = summaryData.questionsAndAnswers[questionIndex];
      let questionNumber = questionIndex + 1;
      let percentage = Math.round((getSafeLocaleString(questionData.responseCount / summaryData.participantCount)) * 100);
      return (!this.props.isLoading && questionData && 
        <div className="col-xs-12" id="by-question-parent" data-count={summaryData.questionCount}>
          {<div data-automation-id="by-question-container">
            <div className="row">
              <SinglePager 
                currentPage={this.currentPage()}
                itemCount={summaryData.questionCount}
                onChange={pageNumber => this.handleChangePage(pageNumber)}
              >
                <div data-automation-id="by-question-title" className="employee-name type-bold color-white" style={{ fontSize: "1.5rem", fontWeight: "lighter" }}>
                    Question {questionNumber}
                  </div>
                  <div data-automation-id="by-question-response-count" style={{ marginTop: '5px' }} className="color-white"> 
                  {getSafeLocaleString(questionData.responseCount)} responses out of {getSafeLocaleString(summaryData.participantCount)} participants ({percentage}%)
                </div>
              </SinglePager>
            </div>
            <div key={questionIndex} className="row type-centeralign" data-automation-id={"summary-question-" + questionIndex}>
              <div className="col-xs-2">
              </div>
              <div className="col-xs-12 padding-vertical">
                <h3 data-automation-id={"question-" + (questionNumber) + "-chart-title"} >{questionNumber}. {questionData.title}</h3>
                {questionData.responseCount > 0 
                  ?
                  <QuestionChart questionData={questionData} questionNumber={questionNumber} isSummary={false}/>
                  : 
                  <NoResult number={questionNumber}/>
                }
              </div>
              <div className="col-xs-2">
              </div>
            </div>
            <BottomPager 
              currentPage={this.currentPage()}
              pageSize={1}
              buttonCount={5}
              itemCount={summaryData.questionCount}
              itemsName="Questions"
              onChange={pageNumber => this.handleChangePage(pageNumber)}
            />
          </div>}
       </div>
      );
    }
    return <ZeroState
              key="by-question-empty-state"
              automationId="empty-state"
              message="Something went wrong! We encountered an error and are unable to process your request. Please try again."
              type="error" />
  }

  currentPage() {
    return this.state.byQuestionPageIndex + 1;
  }

  handleChangePage(pageNumber) {
    this.setState({ byQuestionPageIndex: pageNumber - 1 });
  }


  render() {
    let view = null;
    const isEmbedded = this.isOptionEnabled("embeddedViewerMode");
    if (isEmbedded) {
      if (!this.props.isLoading) {
        view = <React.Fragment>
          { this.props.params.isByQuestion 
            ?
              this.renderByQuestionResults()
            : 
              this.renderSummaryResults()
          }
        </React.Fragment>
      }

      return (
        <React.Fragment>
          <Loader loading={this.props.isLoading} global={true} />
          <FlashMessage />
          {view}
        </React.Fragment>
      );
    }
  }
}

FormSummary.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    params: PropTypes.object.isRequired,
    options: PropTypes.object,
    getSummaryData: PropTypes.func.isRequired,
    summaryData:  PropTypes.object.isRequired,
};

export default FormSummary;